import React, {useEffect, useState} from 'react'
import {Form} from "antd";

const OfferUpdateTotalStockQuantity = ({record}) => {
    const [quantity, setQuantity] = useState()

    useEffect(() => {
        if (record.stock) {
            setQuantity(record.stock.hasOwnProperty('quantity') ? record.stock.quantity : '-')
        }
    }, [record])

    return(
        <React.Fragment>
            <Form>
                <Form.Item>
                    <span>{quantity}</span>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferUpdateTotalStockQuantity